<template>
    <div id="auth">
        <div class="login-section login-form-home" v-show="stage == 'home'">
            <form class="form">
                <img id="logo" src="@/assets/logo.svg" alt="" />
                <div class="form-group" style="margin-bottom: 10px">
                    <button @click.prevent="stage = 'login'" class="button dark">Login</button>
                </div>

                <div class="form-group">
                    <router-link class="button dark center" to="/onboard"
                        >Signup with code</router-link
                    >
                </div>
            </form>
            <div class="login-form-nav-links">
                <router-link to="forgot" class="forgot-password-link"
                    >Forgotten password?</router-link
                >
            </div>
        </div>

        <div class="login-section login-form-token" v-show="stage == 'token'">
            <form class="form" @submit.prevent="registerPendingPlayer">
                <img id="logo" src="@/assets/logo.svg" alt="" />

                <div class="form-group">
                    <label>Enter your email</label>
                    <input type="email" v-model="form2.email" />
                    <has-error :form="form2" field="email"></has-error>
                </div>

                <div class="form-group">
                    <label>Choose a password</label>
                    <password-input data-cy="password" v-model="form2.password" />
                    <has-error :form="form2" field="password"></has-error>
                </div>

                <div class="form-group">
                    <label>Confirm password</label>
                    <password-input
                        data-cy="password_confirmation"
                        v-model="form2.password_confirmation"
                    />
                    <has-error :form="form2" field="password_confirmation"></has-error>
                </div>

                <div class="form-group">
                    <label>Enter 6 digit validation code</label>
                    <input type="text" v-model="form2.token" maxlength="6" />
                    <has-error :form="form2" field="token"></has-error>
                </div>

                <div class="form-group">
                    <button
                        class="button dark"
                        :disabled="form2.busy"
                        data-cy="submit"
                        type="submit"
                        name="button"
                    >
                        {{ form2.busy ? "Please wait..." : "Sign up" }}
                    </button>
                </div>
            </form>

            <div class="login-form-nav-links">
                <a href="" @click.prevent="stage = 'home'">Back to home</a>
            </div>
        </div>

        <div class="login-section login-form" v-show="stage == 'login'">
            <form class="form" @submit.prevent="sendForm">
                <img id="logo" src="@/assets/logo.svg" alt="" />
                <div class="form-group">
                    <label>Email</label>
                    <input data-cy="email" type="email" v-model="form.email" />
                    <has-error data-cy="email_error" :form="form" field="email"></has-error>
                </div>

                <div class="form-group">
                    <label>Password</label>
                    <password-input data-cy="password" v-model="form.password" />
                    <has-error data-cy="password_error" :form="form" field="password"></has-error>
                </div>

                <div class="form-group">
                    <button
                        class="button dark"
                        :disabled="form.busy"
                        data-cy="submit"
                        type="submit"
                        name="button"
                    >
                        {{ form.busy ? "Please wait..." : "Login" }}
                    </button>
                </div>
            </form>
            <div class="login-form-nav-links">
                <a href="" @click.prevent="stage = 'home'">Back to home</a>
                <router-link to="forgot" class="forgot-password-link"
                    >Forgotten password?</router-link
                >
            </div>
        </div>
    </div>
</template>

<script>
import Cookie from "js-cookie";
import PasswordInput from "@/components/App/password-input";
import { Form, HasError } from "vform";
import { ADMIN_LOGIN_MESSAGE, rejectAdminLogin } from "@/utils/rejectAdminLogin";
export default {
    name: "login",
    components: { PasswordInput, HasError },
    data() {
        return {
            oWebViewInterface: window.nsWebViewInterface,
            stage: "home",
            token: "no token",
            form: new Form({
                email: "",
                password: "",
            }),
            form2: new Form({
                email: "",
                password: "",
                password_confirmation: "",
                token: "",
            }),
            playerSubBusy: false,
            proSubBusy: false,
            products: [],
            busy: false,
            test: "Hello",
        };
    },
    mounted() {
        if (this.$route.query.token) {
            this.token = this.$route.query.token;
            try {
                localStorage.setItem("token", this.token);
            } catch (e) {
                console.log(e);
                return false;
            }
        }
    },
    created() {
        if (this.$route.query.home) {
            this.stage = "home";
        }
        if (Cookie.get(process.env.VUE_APP_AUTH_COOKIE_NAME)) {
            window.axios.get("/user").then((response) => {
                if (!rejectAdminLogin(response.data)) {
                    this.$store.dispatch("updateUser", response.data);
                    this.redirectAfterLogin();
                }
            });
        }
    },
    methods: {
        sendForm() {
            this.form
                .post("/login")
                .then((response) => {
                    if (rejectAdminLogin(response.data)) {
                        return;
                    }

                    Cookie.set(process.env.VUE_APP_AUTH_COOKIE_NAME, response.data.api_token);
                    this.$store.dispatch("updateUser", response.data);
                    this.oWebViewInterface.emit("apiTokenRecieved", response.data.api_token);
                    this.redirectAfterLogin();
                })
                .catch((error) => {
                    const emailError = error.response?.data?.errors?.email;
                    const message = Array.isArray(emailError) ? emailError[0] : emailError;

                    if (
                        message === ADMIN_LOGIN_MESSAGE ||
                        message?.includes("nova") ||
                        message?.includes("admin panel")
                    ) {
                        this.form.errors.set("email", ADMIN_LOGIN_MESSAGE);
                        alert(ADMIN_LOGIN_MESSAGE);
                        return;
                    }

                    if (error.response?.status === 401) {
                        alert("Invalid credentials. Please check and try again");
                    }
                });
        },
        registerPendingPlayer() {
            this.form2
                .post("/pending_player/accept")
                .then((response) => {
                    Cookie.set(process.env.VUE_APP_AUTH_COOKIE_NAME, response.data.api_token);
                    this.$store.state.user = response.data;
                    this.oWebViewInterface.emit("apiTokenRecieved", response.data.api_token);
                    this.redirectAfterLogin();
                    this.$notify("Welcome to Lesson Pro");
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        alert("Invalid credentials. Please check and try again");
                    }
                });
        },
        redirectAfterLogin() {
            if (this.$route.query.redirect) {
                this.$router.push(this.$route.query.redirect);
                this.$root.redirectTo = this.$route.query.redirect;
            } else {
                this.$router.push({ name: "Home" });
            }
        },
    },
};
</script>

<style lang="scss">
#subscribeForm {
    p {
        color: white;
        line-height: 1.4;
        text-align: center;
        margin-bottom: 40px;
    }
}
</style>
